import React, { useState } from "react";
import CustomTable from "../../../components/Tables/CustomTable";
import { useAppSelector } from "../../../redux/app/hooks";
import moment from "moment";

const OrderDetailTable = () => {
  const { selectedOrder } = useAppSelector((state) => state.orders);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const columns = [
    { label: "S/N", field: "id" },
    { label: "Name of Item", field: "name_of_item" },
    { label: "Price", field: "price" },
    { label: "Quantity", field: "quantity" },
    { label: "Image", field: "image" },
    { label: "Date", field: "date" },
  ];

  const orderData = selectedOrder?.contract?.contractItem?.map(
    (item: any, index: number) => {
      return {
        id: index + 1,
        name_of_item: item?.productId?.name,
        price: "₦ " + item?.totalCost,
        quantity: item?.productQuantity,
        date: moment(item?.createdAt).format("Do MMM YYYY"),
        image: (
          <button
            type="button"
            onClick={() => {
              setIsModalOpen(true);
              setSelectedImage(item?.productId?.photos[0]);
            }}
            className="p-0 border-none bg-transparent"
            aria-label="View product image"
          >
            <img
              src={item?.productId?.photos[0]}
              className="w-10 h-10"
              alt=""
            />
          </button>
        ),
      };
    }
  );

  return (
    <>
      <CustomTable
        data={{ columns, rows: orderData }}
        // rawData={orderData}
        // tabList={tabList}
      />

      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="bg-white p-4 rounded-lg shadow-lg max-w-lg w-full relative max-h-[90%] "
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
          >
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
              onClick={() => setIsModalOpen(false)}
            >
              ✕
            </button>
            <img
              src={selectedImage}
              alt={"product_image"}
              className="w-full h-full rounded-lg max-h-[500px]"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default OrderDetailTable;
